module.exports = __webpack_public_path__ + "img/img35.b34c8259.png";